var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 3,
    viewBox: "0 0 6 3",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.34151 0.922002L3.39002 2.8433C3.17503 3.05497 2.82773 3.05497 2.61273 2.8433L0.661246 0.922002C0.446251 0.710333 0.446251 0.368406 0.661246 0.156738C0.87624 -0.0549314 1.22354 -0.0549314 1.43853 0.156738L2.99862 1.69269L4.55871 0.156738C4.77371 -0.0549314 5.121 -0.0549314 5.336 0.156738C5.55099 0.368406 5.55099 0.710333 5.336 0.922002H5.34151Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.09b44fcb823ca6fbc5cdefb90cbedee0.svg";
export { ForwardRef as ReactComponent };